import { emptySplitApi as api } from "./emptyApi"
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postUserapiOrgCheckOrg: build.mutation<
      PostUserapiOrgCheckOrgApiResponse,
      PostUserapiOrgCheckOrgApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/checkOrg`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUserapiRoles: build.query<
      GetUserapiRolesApiResponse,
      GetUserapiRolesApiArg
    >({
      query: () => ({ url: `/userapi/roles` }),
    }),
    postUserapiUsersDataAdd: build.mutation<
      PostUserapiUsersDataAddApiResponse,
      PostUserapiUsersDataAddApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUserapiUsersDataLogin: build.mutation<
      PostUserapiUsersDataLoginApiResponse,
      PostUserapiUsersDataLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/login`,
        method: "POST",
        body: queryArg.body,
      }),
    }),

    postOutputScores: build.mutation<
      PostOutputScoresApiResponse,
      PostOutputScoresApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/recruiter/newGetCompositeScores`,
        method: "POST",
        body: queryArg.body,
      }),
    }),

    postFilterUsersByGroup: build.mutation<
      PostOutputScoresApiResponse,
      PostOutputScoresApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/recruiter/filterUsersByGroup`,
        method: "POST",
        body: queryArg.body,
      }),
    }),

    getUserapiAdminTestsGetOrganizationTestByOrganizationId: build.query<
      GetUserapiAdminTestsGetOrganizationTestByOrganizationIdApiResponse,
      GetUserapiAdminTestsGetOrganizationTestByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/adminTests/getOrganizationTest/${queryArg.organizationId}`,
      }),
    }),
    postUserapiUsersDataForgetPasswordMail: build.mutation<
      PostUserapiUsersDataForgetPasswordMailApiResponse,
      PostUserapiUsersDataForgetPasswordMailApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/forgetPasswordMail`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUserapiUsersDataPasswordResetById: build.mutation<
      PostUserapiUsersDataPasswordResetByIdApiResponse,
      PostUserapiUsersDataPasswordResetByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/passwordReset/${queryArg.id}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUserapiResultsSimulationStatus: build.mutation<
      PostUserapiResultsSimulationStatusApiResponse,
      PostUserapiResultsSimulationStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/results/simulationStatus`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postUserapiAdminTestsAssignTest: build.mutation<
      PostUserapiAdminTestsAssignTestApiResponse,
      PostUserapiAdminTestsAssignTestApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/adminTests/assignTest`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUserapiAdminTestsGetTestByIdByTestId: build.query<
      GetUserapiAdminTestsGetTestByIdByTestIdApiResponse,
      GetUserapiAdminTestsGetTestByIdByTestIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/adminTests/getTestById/${queryArg.testId}`,
      }),
    }),
    postUserapiUsersDataAccountByAccountId: build.mutation<
      PostUserapiUsersDataAccountByAccountIdApiResponse,
      PostUserapiUsersDataAccountByAccountIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/account/${queryArg.accountId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUserapiUploadImg: build.mutation<
      PostUserapiUploadImgApiResponse,
      PostUserapiUploadImgApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/upload/img`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUserapiResultsGetSavepointByRunIdByRunId: build.query<
      GetUserapiResultsGetSavepointByRunIdApiResponse,
      GetUserapiResultsGetSavepointByRunIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/results/getSavepointByRunId/${queryArg.runId}`,
      }),
    }),
    postUserapiResultsSavepointByRunId: build.mutation<
      PostUserapiResultsSavepointByRunIdApiResponse,
      PostUserapiResultsSavepointByRunIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/results/savepoint/${queryArg.runId}`,
        method: "POST",
        body: queryArg,
      }),
    }),
    putUserapiResultsFinalResultsByRunId: build.mutation<
      PutUserapiResultsFinalResultsByRunIdApiResponse,
      PutUserapiResultsFinalResultsByRunIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/results/finalResults/${queryArg.runId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postUserapiResultsGenerateRunLog: build.mutation<
      PostUserapiResultsGenerateRunLogApiResponse,
      PostUserapiResultsGenerateRunLogApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/results/generateRunLog`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMeasureScores: build.mutation<
      PostMeasureScoresResponse,
      PostMeasureScoresApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/measures/measureScores`,
        method: "POST",
        body: queryArg.body,
      }),
    }),

    postMicrolearningProgress: build.mutation<
      PostMicrolearningProgressResponse,
      PostMicrolearningProgressApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/microLearning/create`,
        method: "POST",
        body: queryArg.body,
      }),
    }),

    postTraningMailToTeamMember: build.mutation<
      PostTraningMailToTeamMemberResponse,
      PostTraningMailToTeamMemberApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/typeform/webhook/training-form-link/${queryArg.id}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),

    postMeasureOverview: build.mutation<
      PostMeasureOverviewResponse,
      PostMeasureOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/microLearning/measureOverview`,
        method: "POST",
        body: queryArg.body,
      }),
    }),

    postForgetPasswordMail: build.mutation<
      PostUserapiUsersDataForgetMailApiResponse,
      PostUserapiUsersDataForgetMailApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/forgetPasswordMail`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postPasswordReset: build.mutation<
      PostUserapiUsersDataResetPasswordApiResponse,
      PostUserapiUsersDataForgetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/passwordReset/${queryArg.userId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    addNewUserData: build.mutation<
      PostUserapiUsersDataAddNewUserApiResponse,
      PostUserapiUsersDataAddNewUserApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getAllUsersByorganizationId: build.query<
      PostUserapiUsersDataGetAllUsersByOrganizationIdApiResponse,
      PostUserapiUsersDataGetAllUsersByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/getAllUsersByorganizationId`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getCompositeScoresByOrgId: build.query<
      GetCompositeScoresByOrgIdApiResponse,
      GetCompositeScoresByOrgIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/recruiter/sets/${queryArg.orgId}`,
        method: "GET",
      }),
    }),

    getMeasureScoresByUserId: build.query<
      GetMeasureScoresByUserIdApiResponse,
      GetMeasureScoresByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/results/getscores/${queryArg.id}`,
        method: "GET",
      }),
    }),

    getMicroLearningByUserId: build.query<
      GetMicroLearningByUserIdApiResponse,
      GetMicroLearningByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/microLearning/getMicroLearningByUserId/${queryArg.userId}/${queryArg.assignedTestId}`,
        method: "GET",
      }),
    }),

    getMonthByMicroLearningId: build.query<
      GetMonthByMicroLearningIdApiResponse,
      GetMonthByMicroLearningIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/microLearning/getMonthByMicroLearning/${queryArg.microId}`,
        method: "GET",
      }),
    }),

    getWeeksByMonth: build.query<
      GetWeeksByMonthApiResponse,
      GetWeeksByMonthApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/microLearning/getWeeksByMonth/${queryArg.id}`,
        method: "GET",
      }),
    }),

    getCompositeScoresWithBucket: build.query<
      GetCompositeScoresWithBucketApiResponse,
      GetCompositeScoresWithBucketApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/recruiter/getCompositeScoreswithBucket/${queryArg.compositeSetId}/${queryArg.measureId}`,
        method: "GET",
      }),
    }),

    bulkReminder: build.mutation<
      PostUserapiUsersDataBulkReminderApiResponse,
      PostUserapiUsersDataBulkReminderApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/adminUsers/remindUsers`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    csvExport: build.mutation<
      PostUserapiUsersDataCsvExportApiResponse,
      PostUserapiUsersDataCsvExportApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/newUserExport/${queryArg.organizationId}/${queryArg.userId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    csvExportBySearch: build.mutation<
      PostUserapiUsersDataCsvExportApiResponse,
      PostUserapiUsersDataCsvExportApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/usersData/newUserExport/searchUserExport/${queryArg.organizationId}/${queryArg.userId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getGroupsByOrganizationId: build.query<
      PostUserapiUsersDataGetGroupsByOrganizationIdApiResponse,
      PostUserapiUsersDataGetGroupsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/getGroups/${queryArg.organizationId}`,
        method: "GET",
      }),
    }),
    assignUsersToGroup: build.mutation<
      PostUserapiUsersDataAssignUsersToGroupApiResponse,
      PostUserapiUsersDataAssignUsersToGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/assignUsersToGroup`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    removeUsersFromGroup: build.mutation<
      PostUserapiUsersDataRemoveUsersFromGroupApiResponse,
      PostUserapiUsersDataRemoveUsersFromGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/adminUsers/removeUsersFromGroups`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    userCsvImport: build.mutation<
      PostUserapiUsersDataUserCsvImportApiResposne,
      PostUserapiUsersDataUsersCsvImportApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/upload/userImport`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    createGroup: build.mutation<
      PostUserapiUsersDataCreateGroupApiResponse,
      PostUserapiUsersDataCreateGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/createGroup`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateGroup: build.mutation<
      PostUserapiUsersDataUpdateGroupApiResponse,
      PostUserapiUsersDataUpdateGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/updateGroup`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteGroup: build.mutation<
      DeleteUserapiUsersDataDeleteGroupResponse,
      DeleteUserapiUsersDataDeleteGroupApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/deleteGroup/${queryArg.groupId}`,
        method: "DELETE",
      }),
    }),
    getUsersByGroupIds: build.query<
      PostUserapiUsersDataGetUsersByGroupIdsApiResponse,
      PostUserapiUsersDataGetUsersByGroupIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/org/getUsersByorgIdAndGroupIds`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUserapiAdminTestsGetRunId: build.mutation<
      PostUserapiAdminTestsGetRunIdApiResponse,
      PostUserapiAdminTestsGetRunIdApiArg
    >({
      query: (queryArg) => ({
        url: `/userapi/adminTests/getRunId`,
        method: "POST",
        body: queryArg,
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as meseeknaApi }

type CompositeScoresWithBucketType = {
  name: string
  color: string
  bucket: number[]
  set_name: string
  tiers_id: number
  measure_id: number
  measure_name: string
  output_score: number
}
export type GetCompositeScoresWithBucketApiResponse =
  /** status 200 Successful response */ {
    status: string
    message?: string
    code: number
    data: CompositeScoresWithBucketType[]
  }
export type PostUserapiOrgCheckOrgApiResponse =
  /** status 200 Successful response */ {
    status?: string
    message?: string
    code?: number
    data?: {
      id?: number
      organizationName?: string
    }
  }
export type PostUserapiOrgCheckOrgApiArg = {
  body: object
}
export type GetUserapiRolesApiResponse = /** status 200 Successful response */ {
  status?: string
  message?: string
  code?: number
  data?: {
    id?: number
    roleName?: string
    roleCode?: string
    adminAccess?: string
  }[]
}
export type GetUserapiRolesApiArg = void
export type PostUserapiUsersDataAddApiResponse =
  /** status 200 Successful response */
  | {
      status?: string
      message?: string
      code?: number
      data?: {
        id?: number
        active?: string
        creatingMode?: string
        adminId?: string
        firstName?: string
        lastName?: string
        telNumber?: string
        organizationId?: number
        role?: number
        email?: string
        authenticated?: number
        code?: string
        token?: string
        tokenLastUsed?: string
        expiration?: string
        enginePassword?: string
        password?: string
        emailValidated?: number
        signUpTypeId?: number
        socialToken?: string
        imageUrl?: string
        changePassword?: number
        renewal?: number
        createdOn?: string
        referralCode?: string
        totalReferred?: string
        mobileUser?: string
        userName?: string
        status?: number
        drip_status?: number
        remind_email?: number
        expire_status?: number
        time_zone?: string
        organizationName?: string
        roleName?: string
      }[]
    }
  | /** status 208 Successful response */ {
      status?: string
      message?: string
      code?: number
    }
export type PostUserapiUsersDataAddApiArg = {
  body: object
}
export type PostUserapiUsersDataLoginApiResponse =
  /** status 200 Successful response */
  | {
      status?: string
      message?: string
      code?: number
      data?: {
        id?: number
        firstName?: string
        lastName?: string
        email?: string
        organizationId?: number
        role?: number
        imageUrl?: string
        createdOn?: string
        userName?: string
        status?: number
        expire_status?: number
        roleName?: string
        organizationName?: string
        userHash?: string
        token?: string
      }[]
    }
  | /** status 203 Successful response */ {
      status?: string
      message?: string
      code?: number
      data?: object[]
    }
  | /** status 206 Successful response */ {
      status?: string
      message?: string
      code?: number
      data?: object[]
    }
export type PostUserapiUsersDataLoginApiArg = {
  body: object
}
export type GetUserapiAdminTestsGetOrganizationTestByOrganizationIdApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: {
      runId?: number
      id?: number
      testId?: number
      organizationId?: number
      title?: string
      dateImported?: string
      contents?: string
      manualDescription?: string
      organizationName?: string
    }[]
    error?: object
  }
export type GetUserapiAdminTestsGetOrganizationTestByOrganizationIdApiArg = {
  /** The ID of the organization. */
  organizationId: number
}
export type PostUserapiUsersDataForgetPasswordMailApiResponse =
  /** status 200 Successful response */
  | {
      status?: string
      code?: number
      data?: {
        "0"?: {
          id?: number
          firstName?: string
          email?: string
        }
        links?: {
          "subscribers.account"?: string
        }
        subscribers?: {
          id?: string
          href?: string
          status?: string
          email?: string
          first_name?: string
          last_name?: string
          address1?: string
          address2?: string
          city?: string
          state?: string
          zip?: string
          phone?: string
          country?: string
          time_zone?: string
          utc_offset?: number
          visitor_uuid?: string
          custom_fields?: {
            first_name?: string
            order_id?: string
          }
          tags?: {
            "0"?: string
            "1"?: string
            "2"?: string
            "3"?: string
            "4"?: string
            "5"?: string
            "6"?: string
            "7"?: string
            "8"?: string
            "9"?: string
            "10"?: string
            "11"?: string
            "12"?: string
            "13"?: string
          }[]
          created_at?: string
          ip_address?: string
          user_agent?: string
          lifetime_value?: string
          original_referrer?: string
          landing_url?: string
          prospect?: boolean
          base_lead_score?: string
          eu_consent?: string
          sms_number?: string
          sms_consent?: boolean
          lead_score?: string
          user_id?: string
          links?: {
            account?: string
          }
        }[]
      }[]
    }
  | /** status 206 Failure response */ {
      status?: string
      message?: string
      code?: number
    }
export type PostUserapiUsersDataForgetPasswordMailApiArg = {
  body: object
}
export type PostUserapiUsersDataPasswordResetByIdApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: {
      statusCode?: number
      headers?: {
        "content-type"?: string
        "content-length"?: string
        connection?: string
        date?: string
        "x-amzn-requestid"?: string
        "referrer-policy"?: string
        "x-permitted-cross-domain-policies"?: string
        "x-xss-protection"?: string
        "x-runtime"?: string
        "strict-transport-security"?: string
        "x-frame-options"?: string
        "x-amzn-remapped-connection"?: string
        "x-download-options"?: string
        "x-request-id"?: string
        "x-ratelimit-remaining"?: string
        "x-amz-apigw-id"?: string
        "cache-control"?: string
        "x-amzn-remapped-server"?: string
        "x-ratelimit-limit"?: string
        "x-content-type-options"?: string
        "x-amzn-remapped-date"?: string
        "x-cache"?: string
        via?: string
        "x-amz-cf-pop"?: string
        "x-amz-cf-id"?: string
      }
      request?: {
        uri?: {
          protocol?: string
          slashes?: boolean
          auth?: string
          host?: string
          port?: number
          hostname?: string
          hash?: string
          search?: string
          query?: string
          pathname?: string
          path?: string
          href?: string
        }
        method?: string
        headers?: {
          "Content-Type"?: string
          authorization?: string
          "User-Agent"?: string
          accept?: string
          "content-length"?: number
        }
      }
    }
  }
export type PostUserapiUsersDataPasswordResetByIdApiArg = {
  /** accountId */
  id: number
  body: {
    status?: string
    code?: number
    message?: string
    data?: {
      statusCode?: number
      headers?: {
        "content-type"?: string
        "content-length"?: string
        connection?: string
        date?: string
        "x-amzn-requestid"?: string
        "referrer-policy"?: string
        "x-permitted-cross-domain-policies"?: string
        "x-xss-protection"?: string
        "x-runtime"?: string
        "strict-transport-security"?: string
        "x-frame-options"?: string
        "x-amzn-remapped-connection"?: string
        "x-download-options"?: string
        "x-request-id"?: string
        "x-ratelimit-remaining"?: string
        "x-amz-apigw-id"?: string
        "cache-control"?: string
        "x-amzn-remapped-server"?: string
        "x-ratelimit-limit"?: string
        "x-content-type-options"?: string
        "x-amzn-remapped-date"?: string
        "x-cache"?: string
        via?: string
        "x-amz-cf-pop"?: string
        "x-amz-cf-id"?: string
      }
      request?: {
        uri?: {
          protocol?: string
          slashes?: boolean
          auth?: string
          host?: string
          port?: number
          hostname?: string
          hash?: string
          search?: string
          query?: string
          pathname?: string
          path?: string
          href?: string
        }
        method?: string
        headers?: {
          "Content-Type"?: string
          authorization?: string
          "User-Agent"?: string
          accept?: string
          "content-length"?: number
        }
      }
    }
  }
}
export type PostUserapiResultsSimulationStatusApiResponse = {
  /** status 200 Successful response */
  status?: string
  code?: number
  message?: string
  data?: {
    userId?: number
    runId?: number
    microLearningId?: string
    measureId?: string
    microlearningProgress?: string
    dateCompleted?: string
    savePoint?: string
  }[]
}
export type PostUserapiResultsSimulationStatusApiArg = {
  testId: number
  organizationId: number
  userId: number
}
export type PostUserapiAdminTestsAssignTestApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: {
      id?: number
      testId?: number
      userId?: number
      dateAssigned?: string
      dateCompleted?: string
      organizationId?: number
    }[]
  }
export type PostUserapiAdminTestsAssignTestApiArg = {
  body: {
    testId: number
    organizationId: number
    userId: number
  }
}
export type GetUserapiAdminTestsGetTestByIdByTestIdApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: {
      id?: number
      title?: string
      dateImported?: string
      contents?: string
      manualDescription?: string
      whoImported?: string
      active?: string
      forDemo?: string
      assignTo?: string
      pdfURL?: string
      videoURL?: string
      status?: number
    }[]
  }
export type GetUserapiAdminTestsGetTestByIdByTestIdApiArg = {
  /** The ID of the test. */
  testId: number | string
}
export type PostUserapiUsersDataAccountByAccountIdApiResponse =
  /** status 200 Successful response */ {
    status?: string
    message?: string
    code?: number
  }
export type PostUserapiUsersDataAccountByAccountIdApiArg = {
  /** The ID of the account. */
  accountId: number
  body: object
}
export type PostUserapiUploadImgApiResponse =
  /** status 200 Successful response */ {
    status?: string
    message?: string
    code?: number
    data?: {
      id?: number
      active?: string
      creatingMode?: string
      adminId?: string
      firstName?: string
      lastName?: string
      telNumber?: string
      organizationId?: number
      role?: number
      email?: string
      authenticated?: number
      code?: string
      token?: string
      tokenLastUsed?: string
      expiration?: string
      enginePassword?: string
      password?: string
      emailValidated?: number
      signUpTypeId?: number
      socialToken?: string
      imageUrl?: string
      changePassword?: number
      renewal?: number
      createdOn?: string
      referralCode?: string
      totalReferred?: string
      mobileUser?: string
      userName?: string
      status?: number
      drip_status?: number
      remind_email?: number
      expire_status?: number
      time_zone?: string
    }
  }

export type PostOutputScoresApiResponse = {
  status: string
  code: number
  message: string
  data: [
    {
      email: string
      name: string
      groupName: string
      userId: number
      runId: number
      organizationId: number
      B1: number
      B1_output_score: number
      B2: number
      B2_output_score: number
      B3: number
      B3_output_score: number
      B4: number
      B4_output_score: number
      B5: number
      B5_output_score: number
      B6: number
      B6_output_score: number
      B7: number
      B7_output_score: number
      B8: number
      B8_output_score: number
      G1: number
      G1_output_score: number
      G2: number
      G2_output_score: number
      G3: number
      G3_output_score: number
      G4: number
      G4_output_score: number
      G5: number
      G5_output_score: number
      G6: number
      G6_output_score: number
      cplan_count: number
      connections_count: number
      eplan_count: number
      total_connections: number
      rawScoresTotal: number
      compositeScoresTotal: number
      final_Total: number
      raw_total: number
    },
  ]
  error?: object
}

export type PostOutputScoresApiArg = {
  body: {
    organizationId: number
    recruiterId: number
    groups: number[]
    compositeId: number
  }
}

export type PostUserapiUploadImgApiArg = {
  body: {
    name?: Blob
    id?: number
  }
}
export type GetUserapiResultsGetSavepointByRunIdApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: [
      {
        runId?: number
        data?: string
        expiration?: string
        updatedTime?: string
        elapsedTime?: string
      },
    ]
    error?: object
  }

type measureCodeType = {
  B1: number
  B2: number
  B3: number
  B4: number
  B5: number
  B6: number
  B7: number
  B8: number
  G1: number
  G2: number
  G3: number
  G4: number
  G5: number
  G6: number
}

export type GetCompositeScoresByOrgIdApiResponse =
  /** status 200 Successful response */ {
    data: [
      {
        org_id: number
        id: number
        name: string
        buckets_count: number
        // buckets_data: string
        buckets_data: [
          {
            measure_id: number
            measure_name: string
            measure_code: keyof measureCodeType
            min_value: number
            max_value: number
            description: string
            color: string
          },
        ]
      },
    ]
    status: string
    code?: number
    message?: string
  }

export type MeasureScoresByUserIdArray = {
  id: number
  userId: number
  measureId: number
  measureName: string
  runId: number
  score: number
  isSuperPower: boolean
  isMicroLearning: number
  createdOn: string
  description: string
  iconUrl: string
}

export type GetMeasureScoresByUserIdApiResponse = {
  status: string
  code?: number
  message?: string
  data: MeasureScoresByUserIdArray[]
}

export type GetMicroLearningByUserIdApiResponse = {
  status: string
  code?: number
  message?: string
  data: UserMicroLearning[]
}

export type UserMicroLearningMonth = {
  id: number
  userMicrolearningId: number
  monthNumber: number
  monthStatus: number
  monthDescription: string | null
  createdOn: string // Timestamp in ISO format (e.g., "2025-03-24T12:34:56Z")
  weeks: UserMicroLearningWeek[]
}

export type GetMonthByMicroLearningIdApiResponse = {
  status: string
  code?: number
  message?: string
  data: UserMicroLearningMonth[]
}

export type UserMicroLearningWeek = {
  id: number
  userMicroLearningMonthsId: number
  weekNumber: number
  prompt: string | null
  response: string | null
  score: number | null
  startDate: string | null
  endDate: string | null
  weekStatus: number
  mailOpenStatus: number
  mailResponseStatus: number
  mailOpenDate: string | null
  mailResponseDate: string | null
  createdOn: string
  updateMonthStatus: number
  typeFormId: string | null
}

export type GetWeeksByMonthApiResponse = {
  status: string
  code?: number
  message?: string
  data: UserMicroLearningWeek[]
}

export type MeasureDetail = {
  measureId: number
  score: number
  microlearningProgress: string
  measureName: string
  description: string
  iconUrl: string
}

export type MeasureGoalApiResponse = {
  superPower: MeasureDetail
  microLearningGoal: MeasureDetail
}

export type PostMeasureOverviewResponse = {
  status: string
  code?: number
  message?: string
  data: {
    superPower: MeasureDetail
    microLearningGoal: MeasureDetail
  }
}

export type GetUserapiResultsGetSavepointByRunIdApiArg = {
  /** runId */
  runId: number
}

export type GetCompositeScoresByOrgIdApiArg = {
  /** orgId */
  orgId: number
}

export type GetMeasureScoresByUserIdApiArg = {
  /** User Id */
  id: number
}

export type GetWeeksByMonthApiArg = {
  /** User Id */
  id: number
}
export type GetMicroLearningByUserIdApiArg = {
  /** User Id */
  userId: number
  assignedTestId: number
}

export type GetMonthByMicroLearningIdApiArg = {
  /** micro Id */
  microId: number
}
export type GetCompositeScoresWithBucketApiArg = {
  /** compositeSetId */
  compositeSetId: number
  /** measureId */
  measureId: number
}
export type PostUserapiResultsSavepointByRunIdApiResponse =
  /** status 200 Successful response */ any
export type PostUserapiResultsSavepointByRunIdApiArg = {
  /** runId. */
  runId: number
  datetime: string
  runTimer: string
  data: object
}
export type PutUserapiResultsFinalResultsByRunIdApiResponse =
  /** status 200 Successful response */ Blob
export type PutUserapiResultsFinalResultsByRunIdApiArg = {
  /** runId. */
  runId: number
  body: object
}
export type PostMeasureScoresResponse = {
  status?: string
  message: string
  code?: number
  data?: string
}

export type UserMicroLearning = {
  id: number
  userId: number
  measureId: number
  microlearningProgress: string
  createdOn: string
  assignedTestId: number
  months: UserMicroLearningMonth[]
}

export type PostMicrolearningProgressResponse = {
  status: string
  code?: number
  message?: string
  data: UserMicroLearning[]
}

export type PostTraningMailToTeamMemberResponse = {
  status: string
  data: string
}

export type PostUserapiResultsGenerateRunLogApiResponse =
  /** status 200 Successful response */ {
    status?: string
    message?: string
    code?: number
    data?: {
      fieldCount?: number
      affectedRows?: number
      insertId?: number
      serverStatus?: number
      warningCount?: number
      message?: string
      protocol41?: boolean
      changedRows?: number
    }
  }
export type PostUserapiResultsGenerateRunLogApiArg = {
  body: { id: number }
}

export type PostMeasureScoresApiArg = {
  body: {
    runId: number
    userId: number
    testId: number
  }
}

export type PostMicrolearningProgressApiArg = {
  body: {
    measureId: number
    userId: number
    progress: string
  }
}

export type PostTraningMailToTeamMemberApiArg = {
  id: number
  body: {
    eamil: string
    firstName: string
    organizationName: string
  }
}

export type PostMeasureOverviewApiArg = {
  body: {
    userId: number
    measureId: number
  }
}
export type PostUserapiUsersDataForgetMailApiResponse =
  | {
      data: {
        status: string
        message: string
        code: 200
        data?: DripSubscriber[]
      }
      status?: string
    }
  | {
      error: {
        status: string
        message: string
        code?: 404
      }
    }
  | {
      data: {
        status: string
        message: string
        code: 206
      }
    }

export interface DripSubscriber {
  id?: string
  href?: string
  status?: string
  email?: string
  first_name?: string
  last_name?: string | null
  address1?: string | null
  address2?: string | null
  city?: string | null
  state?: string | null
  zip?: string | null
  phone?: string | null
  country?: string | null
  time_zone?: string
  utc_offset?: number
  visitor_uuid?: string | null
  custom_fields?: {
    company?: string
    first_name?: string
    order_id?: string
  }
  tags?: string[]
  created_at?: string
  ip_address?: string | null
  user_agent?: string | null
  lifetime_value?: number | null
  original_referrer?: string | null
  landing_url?: string | null
  prospect?: boolean
  base_lead_score?: number | null
  eu_consent?: string
  sms_number?: string | null
  sms_consent?: boolean
  lead_score?: number
  user_id?: string | null
  links?: {
    account?: string
  }
}

export type PostUserapiUsersDataForgetMailApiArg = {
  body: object
}
export type PostUserapiUsersDataResetPasswordApiResponse = {
  status?: string
  message?: string
  code?: number
  data?: []
}

export type PostUserapiUsersDataForgetPasswordApiArg = {
  userId: any
  body: {
    password: string
  }
}
export type PostUserapiUsersDataAddNewUserApiResponse = {
  status?: string
  message?: string
  code?: number
  data?: {
    code?: number
    message?: string
    status?: string
  }
}

export type PostUserapiUsersDataAddNewUserApiArg = {
  body: {
    Terms: boolean
    acknowledge: boolean
    email: string
    firstName: string
    organizationId: string
    password: string
    role: string
    userName: string
  }
}

export type PostUserapiUsersDataGetAllUsersByOrganizationIdApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: string | number
    message?: string
    data?: [
      {
        id?: number
        email?: string
        firstName?: string
        lastName?: string
        role?: number
        password?: string
        expire_status?: number
        dateCompleted?: string | null
        roleName?: string
        savepoint?: string
        groupName?: string | null
      },
    ]
    error?: object
  }

export type PostUserapiUsersDataGetAllUsersByOrganizationIdApiArg = {
  body: {
    organizationId: number
  }
}

export type PostUserapiUsersDataBulkReminderApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    error?: object
  }

export type PostUserapiUsersDataBulkReminderApiArg = {
  body: {
    status: string
    orgId: number
    users: { email: string }[]
  }
}

export type PostUserapiUsersDataCsvExportApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: [
      {
        firstName: string
        lastName: string
        email: string
        role: string
        groupName: string | null
        status: string
        activateLink: string
      },
    ]
    error?: object
  }

export type PostUserapiUsersDataCsvExportApiArg = {
  organizationId: number
  userId: string
  body: {
    data?: {
      id?: number
      email?: string
      firstName?: string
      lastName?: string
      role?: number
      password?: string
      expire_status?: number
      dateCompleted?: string | null
      roleName?: string
      savepoint?: string
      groupName?: string | null
      checked?: boolean
    }[]
    groupId?: string | string[]
  }
}

export type PostUserapiUsersDataGetGroupsByOrganizationIdApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: [
      {
        id: number
        name: string
        organizationId: number
        createdBy: number
        modifiedBy: string | number | null
        createdOn: string
        status: number
      },
    ]
    error?: object
  }

export type PostUserapiUsersDataGetGroupsByOrganizationIdApiArg = {
  organizationId: number
}

export type PostUserapiUsersDataAssignUsersToGroupApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    existingUsersData: {
      userId: number
      groupId: number
      message: string
    }[]
    data?: {
      fieldCount: number
      affectedRows: number
      insertId: number
      serverStatus: number
      warningCount: number
      message: string
      protocol41: boolean
      changedRows: number
    }
    error?: object
  }

export type PostUserapiUsersDataAssignUsersToGroupApiArg = {
  body: {
    userIds: number[]
    groupIds: number[]
    organizationId: number
    createdBy: number
  }
}

export type PostUserapiUsersDataRemoveUsersFromGroupApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    message?: string
    data?: {
      fieldCount: number
      affectedRows: number
      insertId: number
      serverStatus: number
      warningCount: number
      message: string
      protocol41: boolean
      changedRows: number
    }
    error?: object
  }

export type PostUserapiUsersDataRemoveUsersFromGroupApiArg = {
  body: {
    userIds: number[]
    groupId: number
    organizationId: number
    createdBy: number
  }
}

export type PostUserapiUsersDataUserCsvImportApiResposne =
  /** status 200 Successful response */ {
    status?: string
    code?: number
    errorData?: {
      role: number
      firstName: string
      lastName: string
      organizationId: string
      recruiterId: string
      email: string
      status: string
      remarks: string
    }[]
    insertedCount?: string
    insertedMail?: {
      role: number
      firstName: string
      lastName: string
      organizationId: string
      recruiterId: string
      email: string
      status: string
    }[]
  }

export type PostUserapiUsersDataUsersCsvImportApiArg = {
  body: FormData
}

export type PostUserapiUsersDataCreateGroupApiResponse =
  /** status 200 Successful response */ {
    status?: string
    message?: string
    code?: number
  }

export type PostUserapiUsersDataCreateGroupApiArg = {
  body: {
    name: string
    organizationId: number
    createdBy: number
  }
}

export type PostUserapiUsersDataUpdateGroupApiResponse =
  /** status 200 Successful response */ {
    status?: string
    message?: string
    code?: number
  }

export type PostUserapiUsersDataUpdateGroupApiArg = {
  body: {
    name: string
    groupId: number
    organizationId: number
    modifiedBy: number
  }
}

export type DeleteUserapiUsersDataDeleteGroupResponse =
  /** status 200 Successful response */ {
    status: string
    code: string
    message: string
    data: {
      fieldCount: number
      affectedRows: number
      insertId: number
      serverStatus: number
      warningCount: number
      message: string
      protocol41: boolean
      changedRows: number
    }
  }

export type DeleteUserapiUsersDataDeleteGroupApiArg = {
  groupId: number
}

export type PostUserapiUsersDataGetUsersByGroupIdsApiResponse =
  /** status 200 Successful response */ {
    status?: string
    code?: string | number
    message?: string
    data?: {
      id?: number
      email?: string
      firstName?: string
      lastName?: string
      role?: number
      password?: string
      expire_status?: number
      dateCompleted?: string | null
      roleName?: string
      savepoint?: string
      groupName?: string | null
    }[]
  }

export type PostUserapiUsersDataGetUsersByGroupIdsApiArg = {
  body: { organizationId: number; groupIds: string[] }
}

export type PostUserapiAdminTestsGetRunIdApiArg = {
  testId: number
  organizationId: number
  userId: number
}

export type PostUserapiAdminTestsGetRunIdApiResponse = {
  status?: string
  code?: number
  message?: string
  data?: {
    runId?: number
    // Add any other fields returned by the backend if needed
  }
}

export const {
  usePostUserapiOrgCheckOrgMutation,
  useGetUserapiRolesQuery,
  usePostUserapiUsersDataAddMutation,
  usePostUserapiUsersDataLoginMutation,
  useGetUserapiAdminTestsGetOrganizationTestByOrganizationIdQuery,
  usePostUserapiUsersDataForgetPasswordMailMutation,
  usePostUserapiUsersDataPasswordResetByIdMutation,
  usePostUserapiResultsSimulationStatusMutation,
  usePostUserapiAdminTestsAssignTestMutation,
  useGetUserapiAdminTestsGetTestByIdByTestIdQuery,
  usePostUserapiUsersDataAccountByAccountIdMutation,
  usePostUserapiUploadImgMutation,
  useGetUserapiResultsGetSavepointByRunIdByRunIdQuery,
  usePostUserapiResultsSavepointByRunIdMutation,
  usePutUserapiResultsFinalResultsByRunIdMutation,
  usePostUserapiResultsGenerateRunLogMutation,
  usePostMeasureScoresMutation,
  usePostMicrolearningProgressMutation,
  usePostTraningMailToTeamMemberMutation,
  usePostMeasureOverviewMutation,
  usePostForgetPasswordMailMutation,
  usePostPasswordResetMutation,
  useAddNewUserDataMutation,
  useGetAllUsersByorganizationIdQuery,
  useBulkReminderMutation,
  useCsvExportMutation,
  useCsvExportBySearchMutation,
  useGetGroupsByOrganizationIdQuery,
  useAssignUsersToGroupMutation,
  useRemoveUsersFromGroupMutation,
  useUserCsvImportMutation,
  useCreateGroupMutation,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
  useGetUsersByGroupIdsQuery,
  useGetCompositeScoresByOrgIdQuery,
  usePostFilterUsersByGroupMutation,
  useGetCompositeScoresWithBucketQuery,
  usePostOutputScoresMutation,
  useGetMeasureScoresByUserIdQuery,
  useLazyGetMeasureScoresByUserIdQuery,
  useGetWeeksByMonthQuery,
  useLazyGetWeeksByMonthQuery,
  useGetMicroLearningByUserIdQuery,
  useLazyGetMicroLearningByUserIdQuery,
  useGetMonthByMicroLearningIdQuery,
  usePostUserapiAdminTestsGetRunIdMutation,
} = injectedRtkApi
